import { generateUtilityClasses } from '@mui/material';

export const infoButtonClasses = generateUtilityClasses('InfoButton', ['icon']);
